import { makeStyles } from "@material-ui/core";

export const useMessagesStyles = makeStyles(theme => ({
  messagesRoot: {
    backgroundColor: "#0C0A09",
    color: "#fff",
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    flexDirection: "column",
  },
  messagesContainer: {
    width: "100%",
    maxWidth: 1310,
    margin: "0 auto 0 0",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "24px 130px 24px 40px",
    gap: "20px",
    height: "100%",
    flexGrow: 1,
    [theme.breakpoints.down("md")]: {
      padding: "15px 20px",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      padding: "0",
      height: "calc(100vh - 70px)",
    },
  },
  messagesMain: {
    display: "flex",
    width: "100%",
    height: "100%",
    flexGrow: 1,
    gap: "20px",
  },
  headerTitle: {
    fontSize: "24px",
    fontWeight: 700,
    color: "#FFFFFF",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  headerPar: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#D9D3D3",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  chatSidebar: {
    width: "550px",
    maxWidth: "550px",
    minWidth: "550px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    [theme.breakpoints.down("lg")]: {
      width: "380px",
      maxWidth: "380px",
      minWidth: "380px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
      position: "absolute",
      top: "70px",
      left: 0,
      height: "calc(100vh - 70px)",
      zIndex: 1000,
      backgroundColor: "#0f0f0f",
      padding: "20px",
      boxSizing: "border-box",
    },
  },
  searchTypeButton: {
    minWidth: 120,
    color: "#707C97",
    backgroundColor: "#131313",
    borderLeft: "1px solid #363636",
    borderRadius: "0px",
  },
  menu: {
    "& .MuiPaper-root": {
      color: "#707C97",

      borderRadius: 8,
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      minWidth: 150,
    },
    "& .MuiMenuItem-root": {
      fontSize: "0.875rem",
      padding: theme.spacing(1, 2),
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
      "&.Mui-selected": {
        backgroundColor: theme.palette.action.selected,
      },
    },
  },
  menuHelp: {
    "& .MuiPaper-root": {
      color: "#707C97",
      borderRadius: 8,
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      backgroundColor: "transparent",
      display: "flex",
      columnGap: "10px",
      rowGap: "10px",
    },
    "& ul.MuiList-root": {
      display: "flex",
      flexDirection: "column",
      rowGap: "4px",
    },

    "& .MuiMenuItem-root": {
      fontSize: "0.875rem",
      display: "flex",
      columnGap: "10px",
      rowGap: "10px",
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
      "&.Mui-selected": {
        backgroundColor: theme.palette.action.selected,
      },
    },
  },
  customAttachmentMenu: {
    position: "absolute",
    bottom: "70px",
    right: "15px",
    left: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    zIndex: 10,
    [theme.breakpoints.down("sm")]: {
      bottom: "54px",
    },
  },

  menuPopoverRoot: {
    position: "absolute",
    inset: "auto",
  },

  mediaPreviewWrapper: {
    //     position: "relative",
    marginRight: "10px",
  },

  chatSidebarHidden: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  chatWindow: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    height: "90%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "calc(100vh - 70px)",
    },
  },
  chatWindowHidden: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 20,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      marginBottom: 20,
      gap: "15px",
    },
  },
  headerItem: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0,
      width: "100%",
    },
  },
  newChatButton: {
    border: "1px solid #FE5A97",
    borderRadius: 6,
    backgroundColor: "transparent",
    color: "#FFFFFF",
    flexShrink: 0,
    width: 40,
    height: 40,
    "& svg": {
      width: 20,
      height: 20,
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      borderColor: "#FE5A97",
      color: "#FE5A97",
    },
  },
  searchWrapper: {
    marginBottom: 20,
    display: "flex",
    flexShrink: 0,
  },
  chatInputMessages: {
    display: "flex",
    backgroundColor: "#131313",
    border: "1px solid #363636",
    padding: "10px",
    color: "#707C97",
    minWidth: "100px",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "12px 16px",
      fontSize: "14px",
      borderLeft: "none",
    },
  },
  searchInput: {
    backgroundColor: "#FFFFFF0D",
    borderRadius: 8,
    padding: "6px 12px 6px 12px",
    color: "#FFFFFF",
    width: "100%",
    "& .MuiInputBase-input": {
      color: "#FFFFFF",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "rgba(255, 255, 255, 0.6)",
      opacity: 1,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px 16px",
      fontSize: "14px",
    },
  },
  chatList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    overflowY: "auto",
    flexGrow: 1,
    paddingRight: "5px",
    minHeight: 0,
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#1a1a1a",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#B7BDCB",
      borderRadius: "4px",
      "&:hover": {
        background: "#A0A6B5",
      },
    },
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(1),
      paddingRight: "2px",
    },
  },
  chatNameWrites: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#FFFFFFCC",
    maxWidth: "320px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  chatItem: {
    display: "flex",
    backgroundColor: "#131313",
    padding: "8px 27px 8px 12px",
    borderRadius: 8,
    cursor: "pointer",
    flexDirection: "column",
    rowGap: "17px",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "#1f1f1f",
    },
  },
  chatItemActive: {
    display: "flex",
    backgroundColor: "#FE5A97",
    padding: "8px 27px 8px 12px",
    borderRadius: 8,
    cursor: "pointer",
    flexDirection: "column",
    rowGap: "17px",
    flexShrink: 0,
    "& $chatTime": {
      color: "#FFFFFF",
    },
    "&:hover": {
      backgroundColor: "#FE5A97",
    },
  },
  swipeContainer: {
    position: "relative",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      overflow: "hidden",
    },
  },
  deleteButtonWrapper: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "80px",
    zIndex: 0,
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  deleteButton: {
    width: "100%",
    height: "100%",
    borderRadius: "0 8px 8px 0",
    "&:hover": {
      backgroundColor: "#d32f2f",
    },
  },
  chatItemTop: {
    display: "flex",
    justifyContent: "space-between",
  },
  chatItemLeft: {
    display: "flex",
    alignItems: "center",
    columnGap: "10px",
    [theme.breakpoints.down("sm")]: {
      columnGap: "8px",
    },
  },
  chatNameItem: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#FFFFFF",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  chatItemName: {
    minWidth: 0,
    overflow: "hidden",
  },
  chatText: {
    flexGrow: 1,
    overflow: "hidden",
  },
  chatMessage: {
    fontSize: "15px",
    color: "#FFFFFF",
    fontWeight: 400,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
  chatTime: {
    fontSize: "12px",
    fontWeight: 400,
    color: "#A3A3A3",
  },
  chatItemAvatar: {
    width: 48,
    height: 48,
    flexShrink: 0,
  },
  chatHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 0,
    backgroundColor: "transparent",
    padding: 0,
    position: "relative",
  },
  chatUserInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      gap: theme.spacing(1.5),
    },
    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(1),
      marginLeft: "53px",
    },
  },
  chatHeaderAvatar: {
    width: 60,
    height: 60,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: 48,
      height: 48,
      marginTop: "20px",
    },
  },
  chatUser: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#FFFFFF",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  chatUserNameHelp: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#FE5A97",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      lineHeight: "100%",
    },
  },
  chatStatus: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#FF68D5",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  chatHeaderActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      columnGap: "12px",
    },
  },
  chatHeaderActionButton: {
    color: "#FFFFFF",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    padding: 0,
    [theme.breakpoints.down("sm")]: {
      width: "30px",
      height: "30px",
    },
  },
  messagesArea: {
    flexGrow: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: "20px",
    paddingTop: 0,
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#1a1a1a",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#b7bdcb0e",
      borderRadius: "4px",
      "&:hover": {
        background: "#A0A6B5",
      },
    },
    [theme.breakpoints.down("md")]: {
      padding: "0 15px 15px 15px",
      gap: theme.spacing(1.5),
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0 21px 20px 21px",
      gap: theme.spacing(1),
    },
  },
  messageContainer: {
    display: "flex",
    width: "100%",
    marginBottom: theme.spacing(1),
  },
  messageContainerLeft: {
    justifyContent: "flex-start",
    alignItems: "flex-end",
  },
  messageContainerRight: {
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  messageWrapper: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "70%",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      maxWidth: "75%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "80%",
    },
  },
  messageWrapperRight: {
    alignItems: "flex-end",
  },
  messageWrapperLeft: {
    alignItems: "flex-start",
  },
  messageContent: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    position: "relative",
  },
  messageLeft: {
    backgroundColor: "#1F1F1F",
    color: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 400,
    padding: theme.spacing(1.5),
    borderRadius: 8,
    position: "relative",
    [theme.breakpoints.down("xs")]: {
      padding: "1px 6px",
      "& .MuiTypography-root": {
        fontSize: "14px",
        padding: 0,
      },
    },
  },
  messageLeftVideoRequest: {
    border: "1px solid #D7A7B9",
    padding: "6px",
  },
  messageLeftTip: {
    border: "1px solid #D7A7B9",
  },
  messageRight: {
    backgroundColor: "#FFD0E1",
    padding: theme.spacing(1.5),
    borderRadius: 8,
    borderBottomRightRadius: 0,
    color: "#0C0A09",
    position: "relative",
    "& .MuiTypography-body1": {
      color: "#0C0A09",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "1px 6px",
      "& .MuiTypography-root": {
        fontSize: "14px",
        padding: 0,
      },
    },
  },
  messageRightMedia: {
    padding: "6px",
    borderRadius: 6,
    borderBottomRightRadius: 6,
  },
  messageRightTip: {
    backgroundColor: "#FF78AA",
    color: "#FFFFFF",
  },
  messageRightRejection: {
    padding: 0,
  },
  messageLeftRejection: {
    padding: 0,
  },
  messageMenuButton: {
    visibility: "visible",
    opacity: 1,
    transition: "all 0.2s ease",
    width: "24px",
    height: "24px",
    minWidth: "24px",
    padding: "0",
    backgroundColor: "transparent",
    color: "#fff",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "20px",
      height: "20px",
      minWidth: "20px",
    },
  },
  messageInfo: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    marginTop: "4px",
    fontSize: "11px",
    color: "#747474",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
  messageInfoRight: {
    justifyContent: "flex-end",
    color: "#747474",
  },
  messageAvatar: {
    width: 44,
    height: 44,
    flexShrink: 0,
    margin: "auto 0",
    [theme.breakpoints.down("xs")]: {
      width: 28,
      height: 28,
    },
  },
  messageInfoLeft: {
    justifyContent: "flex-start",
  },
  messageTime: {
    fontSize: "11px",
    color: "#747474",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
  messageStatus: {
    display: "flex",
    alignItems: "center",
    "& .MuiSvgIcon-root": {
      fontSize: "12px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "11px",
      },
    },
  },
  messageStatusRead: {
    color: "#FFFFFF",
  },
  messageStatusSent: {
    color: "#FFFFFF",
  },
  messageMenu: {
    "& .MuiPaper-root": {
      backgroundColor: "#1a1a1a",
      color: "#fff",
      border: "1px solid #363636",
    },
    "& .MuiMenuItem-root": {
      "&:hover": {
        backgroundColor: "#2a2a2a",
      },
    },
  },
  verifiedIcon: {
    color: "rgba(254, 90, 151, 1)",
  },
  nameLink: {
    textDecoration: "none",
    color: "inherit",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    "&:hover": {
      textDecoration: "none",
      color: "inherit",
      cursor: "pointer",
    },
  },
  iconButtonLabel: {
    width: "auto", // або конкретна ширина, наприклад "40px"
    marginTop: "7px",
  },
  pinkBorderButton: {
    border: "1px solid #FE5A9780",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 12,
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      padding: 7,
    },
  },

  chatInputRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "20px",
    minHeight: "56px",
    [theme.breakpoints.down("sm")]: {
      minHeight: "48px",
      padding: "0 21px",
      gap: "8px",
    },
  },
  chatInputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    padding: "12px 16px",
    backgroundColor: "#1F1F1F",
    borderRadius: "25px",
    flexGrow: 1,
    height: "56px",
    [theme.breakpoints.down("sm")]: {
      padding: "6px",
      height: "32px",
    },
  },
  plusIconImg: {
    width: 24,
    height: 24,
    display: "block",
  },
  sendIconImg: {
    width: 24,
    height: 24,
    display: "block",
  },
  chatInput: {
    flexGrow: 1,
    backgroundColor: "transparent",
    padding: "10px 16px",
    color: "#fff",
    border: "none",
    outline: "none",
    height: "40px",
    fontSize: "14px",
    "&::placeholder": {
      color: "#707C97",
    },
    [theme.breakpoints.down("md")]: {
      height: "35px",
      padding: "8px 12px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "30px",
      padding: "6px 10px 6px 0",
      fontSize: "12px",
    },
  },
  sendButton: {
    backgroundColor: "#FE5A97",
    color: "#fff",
    width: "48px",
    height: "48px",
    minWidth: "48px",
    minHeight: "48px",
    flex: "0 0 48px",
    padding: "0",
    margin: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    flexShrink: 0,
    overflow: "hidden",
    boxSizing: "border-box",
    "& .MuiIconButton-label": {
      marginTop: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "&:hover": {
      backgroundColor: "#FE5A97",
    },
    "&.Mui-disabled": {
      backgroundColor: "#FE5A97",
    },
    "& svg": {
      width: 24,
      height: 24,
      flexShrink: 0,
    },
    "& img": {
      width: 24,
      height: 24,
      flexShrink: 0,
    },
    [theme.breakpoints.down("sm")]: {
      width: "32px",
      height: "32px",
      minWidth: "32px",
      minHeight: "32px",
      flex: "0 0 32px",
      "& svg": {
        width: 18,
        height: 18,
      },
      "& img": {
        width: 18,
        height: 18,
      },
    },
  },
  menuPaper: {
    top: "835px !important", // override inline top
  },
  chatHeaderActionsButtons: {
    display: "flex",
    columnGap: "10px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      rowGap: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      rowGap: "10px",
    },
  },
  attachmentContainer: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row-reverse",
      marginRight: "29px",
      gap: 4,
    },
  },
  attachmentButton: {
    backgroundColor: "transparent",
    color: "#FFD0E1",
    width: "40px",
    height: "40px",
    minWidth: "40px",
    maxWidth: "40px",
    padding: "0",
    margin: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
    [theme.breakpoints.down("sm")]: {
      width: "20px",
      height: "20px",
      minWidth: "20px",
      maxWidth: "20px",
    },
  },
  attachmentButtonHelp: {
    backgroundColor: "#FE5A97",
    color: "#FFFFFF",
    width: "40px",
    height: "40px",
    minWidth: "40px",
    maxWidth: "40px",
    padding: "0",
    margin: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "rgba(254, 90, 151, 0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      width: "35px",
      height: "35px",
      minWidth: "35px",
      maxWidth: "35px",
    },
  },
  mobileBackButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      position: "absolute",
      top: "50%",
      left: "10px",
      transform: "translateY(-50%)",
      zIndex: 1001,
      backgroundColor: "transparent",
      color: "#fff",
      padding: "8px 6px",
      marginTop: "10px",
      "&:hover": {
        backgroundColor: "#e05bb5",
      },
    },
  },
  fileInput: {
    display: "none",
  },
  fileInputLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0",
    padding: "0",
    cursor: "pointer",
  },
  mediaPreview: {
    maxWidth: "60px",
    maxHeight: "60px",
    borderRadius: "8px",
    objectFit: "cover",
  },
  modalImage: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "90vw",
    maxHeight: "90vh",
    backgroundColor: "#000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2),
    outline: "none",
  },
  modalSubscriptionWrapper: {},
  modalTipWrapper: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#131313",
    padding: "0px",
    width: "500px",
    borderRadius: "16px",
    zIndex: 1401, // має бути вищий за overlay
    boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
    border: "1px solid #363636",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  modalTitle: {
    backgroundColor: "#131313",
    color: "#FE5A97",
    textAlign: "center",
    fontSize: "24px",
    padding: "20px 0",
    borderBottom: "1px solid #363636",
  },
  modalContent: {
    backgroundColor: "#131313",
    color: "#fff",
    padding: "24px",
  },
  modalSubtitle: {
    fontSize: "16px",
    marginBottom: "16px",
    lineHeight: "1.5",
    textAlign: "center",
  },
  tipInputContainer: {
    marginTop: "8px",
  },
  tipLabel: {
    marginBottom: "8px",
    fontSize: "14px",
  },
  tipInput: {
    "& input": {
      color: "#fff",
      backgroundColor: "#1e1e1e",
      MozAppearance: "textfield", // Firefox
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    // Вимикає стрілки в Chrome/Safari
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
  modalActions: {
    backgroundColor: "#131313",
    borderTop: "1px solid #363636",
    padding: "16px",
    justifyContent: "space-between",
  },
  cancelButton: {
    color: "#fff",
    backgroundColor: "#333",
    "&:hover": {
      backgroundColor: "#444",
    },
  },
  nameButSup: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: 1.0,
  },
  buttonAction: {
    backgroundColor: "#EFEFEF",
    color: "#F05D94",
    textTransform: "none",
    padding: theme.spacing(0.5, 1),
    borderRadius: "6px",
    boxShadow: "none",
    fontSize: "0.85rem",
    width: "105px",
    height: "40px",
    "&:hover": {
      backgroundColor: "rgba(240,110,196,0.1)",
    },
    "& .MuiButton-startIcon": {
      marginRight: theme.spacing(0.5),
      "& svg": {
        width: 16,
        height: 16,
      },
    },
    [theme.breakpoints.down("md")]: {
      MaxWidth: "105px",
      width: "125px",
      height: "22px",
    },
    [theme.breakpoints.down("sm")]: {
      MaxWidth: "105px",
      width: "125px",
      height: "22px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0.25, 0.75),
      fontSize: "0.7rem",
      "& .MuiButton-startIcon": {
        marginRight: theme.spacing(0.25),
        "& svg": {
          width: 14,
          height: 14,
        },
      },
    },
  },
  buttonActionVideo: {
    backgroundColor: "#EFEFEF",
    color: "#F05D94",
    textTransform: "none",
    padding: theme.spacing(0.5, 1),
    borderRadius: "6px",
    boxShadow: "none",
    fontSize: "0.85rem",
    width: "125px",
    height: "40px",
    "&:hover": {
      backgroundColor: "rgba(240,110,196,0.1)",
    },
    "& .MuiButton-startIcon": {
      marginRight: theme.spacing(0.5),
      "& svg": {
        width: 16,
        height: 16,
      },
    },
    [theme.breakpoints.down("md")]: {
      MaxWidth: "105px",
      height: "32px",
    },
    [theme.breakpoints.down("sm")]: {
      MaxWidth: "105px",
      height: "32px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0.25, 0.75),
      fontSize: "0.7rem",
      "& .MuiButton-startIcon": {
        marginRight: theme.spacing(0.25),
        "& svg": {
          width: 14,
          height: 14,
        },
      },
    },
  },
  sendButtonHelp: {
    color: "#fff",
    backgroundColor: "#FE5A97",
    "&:hover": {
      backgroundColor: "#E5497F",
    },
  },
  mediaModalButon: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "500px",
    width: "500px",
    backgroundColor: "#131313",
    [theme.breakpoints.down("sm")]: {
      width: "400px",
    },
  },
  mediaModalContentInfo: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
  },
  mediaModalTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FE5A97",
  },
  selectButton: {
    background: "#EFEFEF",
    color: "#FE5A97",
    padding: "10px 20px",
    borderRadius: "6px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#EFEFEF",
    },
  },
  boxSmile: {
    position: "absolute",
    bottom: "90px",
    right: "25px",
    zIndex: 1000,
    [theme.breakpoints.down("sm")]: {
      bottom: "54px",
      right: "15px",
    },
  },
  purchaseButton: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    //   backgroundColor: "#FE5A97",
    color: "#FE5A97",
    border: "1px solid #FE5A97",
    textTransform: "none",
    padding: theme.spacing(1, 2),
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#e04e87",
      color: "#FFFFFF",
      cursor: "pointer",
    },
    zIndex: 2,
  },
  dialogTitleGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#131313",
    color: "#FE5A97",
    fontSize: "24px",
    borderBottom: "1px solid #363636",
  },
  dialogContentGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#131313",
    color: "#FE5A97",
    fontSize: "14px",
    borderBottom: "1px solid #363636",
  },
  textFieldGroup: {
    color: "#fff",
    width: "300px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    padding: "10px 20px",
    backgroundColor: "#1e1e1e",
    //  backgroundColor: "#EFEFEF",
    border: "1px solid #363636",
    "& .MuiInputBase-root": {
      color: "#FFFFFF", // 🎯 колір тексту
    },
    "& .MuiInput-underline:hover": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
  },
  groupChatuserBox: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
    maxHeight: 300,
  },
  boxUserGroup: {
    border: "1px solid #444",
    borderRadius: 8,
    padding: "5px 12px",
    cursor: "pointer",
    width: "500px",
    height: "50px",
    backgroundColor: "rgb(51, 51, 51)",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#2a2a2a",
    },
    [theme.breakpoints.down("sm")]: {
      width: "300px",
    },
  },
  dialogMinTitleGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#131313",
    color: "#FE5A97",
    fontSize: "14px",
    paddingTop: "10px",
    margin: 0,
    padding: "0",
  },

  selectedUser: {
    backgroundColor: "#FE5A97", // або будь-який твій активний колір
    //  color: "#fff",
    color: "rgb(51, 51, 51)",
    "&:hover": {
      backgroundColor: "#f94d8f",
    },
  },
  avatarUserGroup: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    objectFit: "cover",
  },
  nameUserNameGroup: {
    display: "flex",
    flexDirection: "column",
    fontSize: "12px",
  },
  dialogActionsGroupFooter: {
    backgroundColor: "#131313",
    display: "flex",
    justifyContent: "space-between",
  },
  dialogActionsGroupFooterCancel: {
    color: "#fff",
    backgroundColor: "#333",
  },
  dialogActionsGroupFooterCreate: {
    color: "#fff",
    backgroundColor: "#FE5A97",
  },
  textFieldSearchGroup: {
    color: "#fff",
    width: "300px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    padding: "10px 20px",
    backgroundColor: "#1e1e1e",
    //  backgroundColor: "#EFEFEF",
    //  border: "1px solid #363636",
    "& .MuiInputBase-root": {
      color: "#FFFFFF", // 🎯 колір тексту
    },
    "& .MuiInput-underline:hover": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
  },
  menuItemMute: {
    color: "#FFA500",
  },
  menuItemUnmute: {
    color: "#4CAF50",
  },
  menuItemMuteOption: {
    color: "#FFA500",
    fontSize: "14px",
    padding: "8px 16px",
  },
  menuItemBlock: {
    color: "#FE5A97",
  },
  menuItemReport: {
    color: "#FF6B6B",
  },
  noBorder: {
    border: "none",
  },
  dateSeparator: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "16px 0",
    padding: "4px 0",
    "&::before": {
      content: '""',
      flex: 1,
      height: "1px",
      backgroundColor: "#131313",
    },
    "&::after": {
      content: '""',
      flex: 1,
      height: "1px",
      backgroundColor: "#131313",
    },
    "& .MuiTypography-caption": {
      color: "#A3A3A3",
      fontSize: "14px",
      padding: "0 12px",
      flexShrink: 0,
    },
  },
  videoRequestContainer: {
    backgroundColor: "transparent",
    borderRadius: "12px",
    margin: "8px 0",
    maxWidth: "300px",
  },
  videoRequestModalInput: {
    backgroundColor: "#1F1F1F",
    borderRadius: "8px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiInputBase-input": {
      fontSize: "20px",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#FFFFFFCC",
      opacity: 1,
    },
    "& .MuiInputBase-input::-webkit-input-placeholder": {
      color: "#FFFFFFCC",
      opacity: 1,
    },
    "& .MuiInputBase-input::-moz-placeholder": {
      color: "#FFFFFFCC",
      opacity: 1,
    },
    [theme.breakpoints.down("sm")]: {
      "& .MuiInputBase-input": {
        fontSize: "16px",
      },
    },
  },
  videoRequestModalLabel: {
    color: "#FFFFFF",
    fontSize: "20px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  videoRequestModalDisclaimer: {
    color: "#A3A3A3",
    fontSize: "14px",
    marginBottom: 16,
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  videoRequestModalCheckbox: {
    color: "#FFFFFF !important",
    "&.Mui-checked": {
      color: "#FFFFFF !important",
    },
  },
  videoRequestModalActions: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "16px 24px",
    width: "100%",
    boxSizing: "border-box",
  },
  videoRequestModalRejectBtn: {
    backgroundColor: "transparent",
    color: "#FFFFFF",
    height: "48px",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: 600,
    textTransform: "none",
    border: "1px solid #FE5A97",
    width: "100%",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      borderColor: "#FE5A97",
    },
  },
  videoRequestModalAcceptBtn: {
    backgroundColor: "#FE5A97",
    color: "#FFFFFF",
    height: "48px",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: 600,
    textTransform: "none",
    width: "100%",
    "&:hover": {
      backgroundColor: "#FE5A97DD",
    },
    "&:disabled": {
      backgroundColor: "rgba(254, 90, 151, 0.4)",
      color: "rgba(255, 255, 255, 0.7)",
    },
  },
  videoRequestCardCompact: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  videoRequestCardRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
  },
  videoRequestCardText: {
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: 400,
    flex: 1,
  },
  videoRequestCardIcon: {
    width: 20,
    height: 20,
    flexShrink: 0,
  },
  videoRequestSeeDetails: {
    color: "#FF78AA",
    fontSize: "14px",
    fontWeight: 500,
    textAlign: "right",
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: 0,
    textDecoration: "underline",
    "&:hover": {
      color: "#FF78AA",
      textDecoration: "underline",
      opacity: 0.9,
    },
  },
  videoRequestHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  videoRequestTitle: {
    color: "#FE5A97",
    fontSize: "16px",
    fontWeight: 600,
  },
  videoRequestPrice: {
    color: "#4CAF50",
    fontSize: "18px",
    fontWeight: 700,
  },
  videoRequestDescription: {
    color: "#ffffff",
    fontSize: "14px",
    fontStyle: "italic",
    marginBottom: "12px",
    lineHeight: 1.4,
  },
  videoRequestStatus: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  videoRequestStatusText: {
    color: "#707C97",
    fontSize: "12px",
    textTransform: "capitalize",
  },
  videoRequestActions: {
    display: "flex",
    gap: "8px",
  },
  acceptButton: {
    backgroundColor: "#4CAF50",
    color: "#ffffff",
    fontSize: "12px",
    padding: "4px 12px",
    borderRadius: "6px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#45a049",
    },
  },
  rejectButton: {
    backgroundColor: "#f44336",
    color: "#ffffff",
    fontSize: "12px",
    padding: "4px 12px",
    borderRadius: "6px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#da190b",
    },
  },
  uploadButton: {
    backgroundColor: "#2196F3",
    color: "#ffffff",
    fontSize: "12px",
    padding: "4px 12px",
    borderRadius: "6px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1976D2",
    },
  },
  videoReqCancelButton: {
    backgroundColor: "#FF9800",
    color: "#ffffff",
    fontSize: "12px",
    padding: "4px 12px",
    borderRadius: "6px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#F57C00",
    },
  },
  notificationContainer: {
    backgroundColor: "#2a2a2a",
    border: "1px solid #FE5A97",
    borderRadius: "8px",
    padding: "12px 16px",
    margin: "8px 0",
    textAlign: "center",
    maxWidth: "280px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  notificationText: {
    color: "#FE5A97",
    fontSize: "13px",
    fontWeight: 500,
    lineHeight: 1.4,
  },
  tipContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },
  tipContainerIncoming: {},
  tipContainerOutgoing: {},
  tipIconImg: {
    width: 20,
    height: 20,
    flexShrink: 0,
  },
  tipIconImgIncoming: {},
  tipIconImgOutgoing: {
    filter: "brightness(0) invert(1)",
  },
  tipText: {
    fontSize: "13px",
    fontWeight: 500,
    lineHeight: 1.4,
    textAlign: "left",
  },
  tipAmount: {
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: 1.2,
  },
  tipBold: {
    fontWeight: 700,
  },
}));
